module.exports = __webpack_public_path__ + "img/sprinkle-12.275afa60.jpg";